import * as angular from 'angular';
import { TransitionService, StateService, TargetState, UIInjector, Transition } from '@uirouter/core';
import { PreviousStateService } from './previous-state.service';
import { IAuthRouteService } from './models';

function appRun(
    $window: ng.IWindowService,
    $state: StateService,
    $transitions: TransitionService,
    $previousState: PreviousStateService,
    authService: IAuthRouteService
) {
    // Hook not found
    $state.onInvalid(function (to: TargetState, from: TargetState, injector: UIInjector) {
        console.log(to);
    });

    // Hook start
    $transitions.onStart({}, function(transition: Transition) {
        function cancel() {
            transition.abort();
        }
        return authService.checkAccess(cancel, transition.to());
    });

    // Hook success
    $transitions.onSuccess({}, function (transition: Transition) {
        $previousState.set({
            state: transition.from(),
            params: transition.params('from')
        });
        $window.scrollTo(0, 0);
    });
}

angular.module('app.common').run(appRun);

appRun.$inject = ['$window', '$state', '$transitions', '$previousState', 'authService'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/routes/routes.run.ts